
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Kidney_cancer",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Kidney_cancer.vue